import { auth, type SchemaResponse } from "@/modules/api"
import {
  OverViewInfoTikTok,
  TikTokTrendingDataPoint,
  TikTokTrendingInfoParams
} from "@/modules/types/users/tiktok"

export type UpdateGmvCreatorData = {
  liveGmv: number
  videoGmv: number
  totalGmv: number
}

export type UpdateGmvCreatorResponse = {
  error: boolean
  data: UpdateGmvCreatorData
  message: string
  code: number
}

export const updateDataGmvCreator = (userId: string) => {
  return auth.post<UpdateGmvCreatorResponse>("tracking-kol/update-data-gmv-creator", null, {
    params: { userId }
  })
}

export const getInfoTikTok = async () => {
  return auth.get<SchemaResponse<OverViewInfoTikTok>>("third-party/tiktok/profile")
}

export const getTikTokTrendingInfo = async (params: TikTokTrendingInfoParams) => {
  return auth.get<SchemaResponse<TikTokTrendingDataPoint[]>>(
    "tiktok-affiliate-partner/creator-trending-info",
    {
      params
    }
  )
}
